// @flow

import * as VRUtils from './vrUtils';
import * as React from 'react';
import Settings from 'config/Settings';

export function setTimeout(callback: any, time: number): TimeoutID {
  return window.videoPlayer.setTimeout.apply(window.videoPlayer, arguments);
}

export function clearTimeout(id: null | TimeoutID) {
  window.videoPlayer.clearTimeout.apply(window.videoPlayer, arguments);
}

export function unload() {
  window.videoPlayer.handlers.ontime = null;
  window.videoPlayer.handlers.onend = null;
  window.videoPlayer.handlers.onload = null;
  window.videoPlayer.unload();

}
if (window.globalMuted == null) {
  window.globalMuted = false;
}

export function isPlaying() : boolean {
  return window.videoPlayer.video.paused === false;
}

export function setMuted(flag:boolean) {
  window.globalMuted = flag;
  window.videoPlayer.video.muted = flag;
}

export function getMuted():boolean {
  return window.videoPlayer.video.muted === true;
}

export function loadIntro() {
  const src = (process.env.PUBLIC_URL ?? '') + '/video/0_intro';
  const vr = false;
  const loop = false;
  window.videoPlayer.handlers.ontime = null;
  window.videoPlayer.handlers.onend = null;
  window.videoPlayer.load(src, vr, loop);
  VRUtils.ready(function(){
  });

}

export function lookAtDefault() {
  const defaultLookAtPos = [-0.049745982243874214 , -0.49782771759446465 , 2.9579879818628876];
  VRUtils.ready(()=>{
    VRUtils.fireVREvent("smoothLookat", new window.pc.Vec3(defaultLookAtPos[0], defaultLookAtPos[1], defaultLookAtPos[2]) );
  });
  
}

export function loadTutorialBG() {
  const src = (process.env.PUBLIC_URL ?? '') + '/video/twinkle';
  const vr = false;
  const loop = true;
  window.videoPlayer.handlers.ontime = null;
  window.videoPlayer.handlers.onend = null;

  let mobile = false;
  if (window.pc != null && window.pc.platform != null) {
    mobile = window.pc.platform.mobile;
  }

  window.videoPlayer.load(src, vr, loop, null, false, mobile ? 1502 : 3004, mobile ? 540 : 1080);
}

//const languages_all = ["kr_kr", "at_de", "be_dt", "be_fr", "de_de", "es_es", "fr_fr", "it_it", "nl_dt", "se_se", "uk_en"];
const languages_all_na_en = ["kr_kr", "at_de", "be_dt", "be_fr", "de_de", "es_es", "fr_fr", "it_it", "nl_dt", "se_se", "uk_en", "na_en"];
const languages_kruk = ["kr_kr", "uk_en"];
const languages_default = languages_kruk;

function getLocalizedName(src:string, languages?:Array<string>) : string {
  if (languages == null) {
    languages = languages_default;
  }
  if (languages.indexOf(Settings.localKey) >= 0) {
    return src + "_" + Settings.localKey;
  }
  return src;
}


export function loadA04_1() {
  
  const src = getLocalizedName((process.env.PUBLIC_URL ?? '') + '/video/A04_1', languages_all_na_en);
  const vr = false;
  const loop = false;
  window.videoPlayer.handlers.ontime = null;
  window.videoPlayer.handlers.onend = null;
  window.videoPlayer.load(src, vr, loop);
}

export function loadB01_1() {
  const src = (process.env.PUBLIC_URL ?? '') + '/video/B01_1';
  const vr = false;
  const loop = false;
  window.videoPlayer.handlers.ontime = null;
  window.videoPlayer.handlers.onend = null;
  window.videoPlayer.load(src, vr, loop);
}

export function loadB02_1() {

  const src = (process.env.PUBLIC_URL ?? '') + '/video/B02_1';
  const vr = false;
  const loop = false;
  //window.videoPlayer.handlers.ontime = null;
  window.videoPlayer.handlers.onend = null;
  window.videoPlayer.load(src, vr, loop);
}

export function loadB02_2() {
  const src = getLocalizedName((process.env.PUBLIC_URL ?? '') + '/video/B02_2', ["kr_kr"]);
  const vr = false;
  const loop = false;
  window.videoPlayer.handlers.ontime = null;
  window.videoPlayer.handlers.onend = null;
  window.videoPlayer.load(src, vr, loop);
}

export function loadB02_3(loadEnded?: boolean) {
  //const src = (process.env.PUBLIC_URL ?? '') + '/video/B02_3';
  const src = getLocalizedName((process.env.PUBLIC_URL ?? '') + '/video/B02_3', ["na_en", "uk_en"]);
  const vr = false;
  const loop = false;
  window.videoPlayer.handlers.ontime = null;
  window.videoPlayer.handlers.onend = null;
  window.videoPlayer.load(src, vr, loop, loadEnded);
}

export function loadB03_1() {
  //const src = (process.env.PUBLIC_URL ?? '') + '/video/B03_1';
  const src = getLocalizedName((process.env.PUBLIC_URL ?? '') + '/video/B03_1', ["na_en", "uk_en"]);
  const vr = true;
  const loop = false;
  window.videoPlayer.handlers.ontime = null;
  window.videoPlayer.handlers.onend = null;
  window.videoPlayer.load(src, vr, loop);
}
export function loadB03_2() {
  const src = getLocalizedName((process.env.PUBLIC_URL ?? '') + '/video/B03_2', ["na_en", "uk_en"]);
  const vr = true;
  const loop = false;
  window.videoPlayer.handlers.ontime = null;
  window.videoPlayer.handlers.onend = null;
  window.videoPlayer.load(src, vr, loop);
}
export function loadB03_3() {

  const src = getLocalizedName((process.env.PUBLIC_URL ?? '') + '/video/B03_3', ["na_en", "uk_en"]);
  const vr = true;
  const loop = false;
  window.videoPlayer.handlers.ontime = null;
  window.videoPlayer.handlers.onend = null;
  window.videoPlayer.load(src, vr, loop);
}

export function loadB03_4() {

  const src = getLocalizedName((process.env.PUBLIC_URL ?? '') + '/video/B03_4', ["na_en", "uk_en"]);
  const vr = true;
  const loop = false;
  window.videoPlayer.handlers.ontime = null;
  window.videoPlayer.handlers.onend = null;
  window.videoPlayer.load(src, vr, loop);
}

export function loadB03_5() {
  const src = getLocalizedName((process.env.PUBLIC_URL ?? '') + '/video/B03_5', ["na_en", "uk_en"]);
  const vr = true;
  const loop = true;
  window.videoPlayer.handlers.ontime = null;
  window.videoPlayer.handlers.onend = null;
  window.videoPlayer.load(src, vr, loop);
}

export function loadB03_6() {
  const src = getLocalizedName((process.env.PUBLIC_URL ?? '') + '/video/B03_6', ["na_en", "uk_en"]);
  const vr = true;
  const loop = false;
  window.videoPlayer.handlers.ontime = null;
  window.videoPlayer.handlers.onend = null;
  window.videoPlayer.load(src, vr, loop);
}

export function loadB03_7() {
  const src = getLocalizedName((process.env.PUBLIC_URL ?? '') + '/video/B03_7', ["na_en", "uk_en"]);
  const vr = true;
  const loop = false;
  window.videoPlayer.handlers.ontime = null;
  window.videoPlayer.handlers.onend = null;
  window.videoPlayer.load(src, vr, loop);
}

export function loadB03_8() {
  const src = getLocalizedName((process.env.PUBLIC_URL ?? '') + '/video/B03_8', ["na_en", "uk_en"]);
  const vr = true;
  const loop = false;
  window.videoPlayer.handlers.ontime = null;
  window.videoPlayer.handlers.onend = null;
  window.videoPlayer.load(src, vr, loop);
}

export function loadB04_1() {
  const src = getLocalizedName((process.env.PUBLIC_URL ?? '') + '/video/B04_1', ["na_en", "uk_en", "kr_kr"]);
  const vr = true;
  const loop = false;
  window.videoPlayer.handlers.ontime = null;
  window.videoPlayer.handlers.onend = null;
  window.videoPlayer.load(src, vr, loop);
}

export function loadB04_2(loadEnded?: boolean) {
  let src = getLocalizedName((process.env.PUBLIC_URL ?? '') + '/video/B04_2', ["na_en", "uk_en", "kr_kr"]);
  const vr = true;
  const loop = false;
  window.videoPlayer.handlers.ontime = null;
  window.videoPlayer.handlers.onend = null;
  window.videoPlayer.load(src, vr, loop, loadEnded);
  //filename, vr, loop, loadEnded, mobile, width, height
}

export function loadB04_5() {
  const src = getLocalizedName((process.env.PUBLIC_URL ?? '') + '/video/B04_5', ["na_en", "uk_en", "kr_kr"]);
  const vr = true;
  const loop = true;
  window.videoPlayer.handlers.ontime = null;
  window.videoPlayer.handlers.onend = null;
  window.videoPlayer.load(src, vr, loop);
}

export function loadB04_6() {
  const src = getLocalizedName((process.env.PUBLIC_URL ?? '') + '/video/B04_6', ["na_en", "uk_en", "kr_kr"]);
  const vr = true;
  const loop = true;
  window.videoPlayer.handlers.ontime = null;
  window.videoPlayer.handlers.onend = null;
  window.videoPlayer.load(src, vr, loop);
}

export function loadB04_7() {
  const src = getLocalizedName((process.env.PUBLIC_URL ?? '') + '/video/B04_7', ["na_en"]);
  const vr = true;
  const loop = true;
  window.videoPlayer.handlers.ontime = null;
  window.videoPlayer.handlers.onend = null;
  window.videoPlayer.load(src, vr, loop);
}

export function loadB04_8() {
  const src = getLocalizedName((process.env.PUBLIC_URL ?? '') + '/video/B04_8', ["na_en", "uk_en", "kr_kr"]);
  const vr = true;
  const loop = false;
  window.videoPlayer.handlers.ontime = null;
  window.videoPlayer.handlers.onend = null;
  window.videoPlayer.load(src, vr, loop);
}

export function loadB04_9() {
  const src = getLocalizedName((process.env.PUBLIC_URL ?? '') + '/video/B04_9', ["na_en", "uk_en", "kr_kr"]);
  const vr = true;
  const loop = false;
  window.videoPlayer.handlers.ontime = null;
  window.videoPlayer.handlers.onend = null;
  window.videoPlayer.load(src, vr, loop);
}

export function loadB04_10() {
  const src = getLocalizedName((process.env.PUBLIC_URL ?? '') + '/video/B04_10', ["na_en", "uk_en", "kr_kr"]);
  const vr = false;
  const loop = false;
  window.videoPlayer.handlers.ontime = null;
  window.videoPlayer.handlers.onend = null;
  window.videoPlayer.load(src, vr, loop);
}

export function loadB04_11() {
  const src = getLocalizedName((process.env.PUBLIC_URL ?? '') + '/video/B04_11', ["na_en", "uk_en", "kr_kr"]);
  const vr = false;
  const loop = true;
  window.videoPlayer.handlers.ontime = null;
  window.videoPlayer.handlers.onend = null;
  window.videoPlayer.load(src, vr, loop);
}

export function loadB04_12() {
  const src = getLocalizedName((process.env.PUBLIC_URL ?? '') + '/video/B04_12', ["na_en", "uk_en", "kr_kr"]);
  const vr = false;
  const loop = false;
  window.videoPlayer.handlers.ontime = null;
  window.videoPlayer.handlers.onend = null;
  window.videoPlayer.load(src, vr, loop);
}

export function loadB04_13() {
  VRUtils.ready(function(){
    const src = getLocalizedName((process.env.PUBLIC_URL ?? '') + '/video/B04_13', ["na_en", "uk_en", "kr_kr"]);
    const vr = false;
    const loop = false;
    window.videoPlayer.handlers.ontime = null;
    window.videoPlayer.handlers.onend = null;
    window.videoPlayer.load(src, vr, loop);
  });
}

export function loadB04_14() {
  const src = getLocalizedName((process.env.PUBLIC_URL ?? '') + '/video/B04_14', languages_all_na_en);
  const vr = false;
  const loop = false;
  window.videoPlayer.handlers.ontime = null;
  window.videoPlayer.handlers.onend = null;
  window.videoPlayer.load(src, vr, loop);
}

export function loadB04_15() {
  const src = getLocalizedName((process.env.PUBLIC_URL ?? '') + '/video/B04_15', ["kr_kr"]);
  const vr = false;
  const loop = false;
  window.videoPlayer.handlers.ontime = null;
  window.videoPlayer.handlers.onend = null;
  window.videoPlayer.load(src, vr, loop);
}

export function loadB04_16() {
  const src = getLocalizedName((process.env.PUBLIC_URL ?? '') + '/video/B04_16', ["kr_kr"] );
  const vr = false;
  const loop = false;
  window.videoPlayer.handlers.ontime = null;
  window.videoPlayer.handlers.onend = null;
  window.videoPlayer.load(src, vr, loop);
}

export function loadB04_17() {
  const src = getLocalizedName((process.env.PUBLIC_URL ?? '') + '/video/B04_17', ["kr_kr"] );
  const vr = false;
  const loop = false;
  window.videoPlayer.handlers.ontime = null;
  window.videoPlayer.handlers.onend = null;
  window.videoPlayer.load(src, vr, loop);
}

export function play() {
  //console.warn("videoUtils.play");
  window.videoPlayer.play();
}

export function onEnd(onend: () => void) {
  window.videoPlayer.handlers.onend = onend;
}

export function onTime(ontime: (number, number) => void) {
  window.videoPlayer.handlers.ontime = ontime;
}

export function onLoad(onload: () => void) {
  window.videoPlayer.handlers.onload = onload;
}

export function setOnPoint(onpoint:(string, number, number)=>void ) {
  VRUtils.ready(function(){
    window.videoPlayer.handlers.onpoint = onpoint;
  });
}

export function addPoint(key:string, x:number, y:number) {
  VRUtils.ready(function(){
    window.videoPlayer.addPoint(key, x, y);
  });
}

export function removePoint(key:string) {
  VRUtils.ready(function(){
    window.videoPlayer.removePoint(key);
  });
}

export function addPoint3D(key:string, x:number, y:number, z:number, node:any) {
  //console.log("video: in addPoint3D, key=", key);

  if (window.point3DHandler == null) {
    window.point3DData = {};
    window.point3DHandler = function(key:string, x:number, y:number, z:number) {
      const nodeData = window.point3DData[key];
      if (nodeData == null) {
        //console.error("nodeData is null for key=", key);
        return;
      }
      const node = nodeData.node;
      console.assert(node != null);
      if (node != null) {
        if (z >= 0) {
          node.style.transform = "translate(" + x + "px,"+y+"px)";
          node.style.visibility = "";
        } else {
          node.style.visibility = "hidden";
        }
      }      
    };

    //console.log("video: in adding handler, event_key=", event_key);
    const event_key = "pointController:handlers:onpoint";
    VRUtils.addVREventListener(event_key, window.point3DHandler);
    
  }

  if (node != null) {
    window.point3DData[key] = {node : node};
  } else {
    removePoint3D(key);
    delete window.point3DData[key];
  }

  const eventName = "pointController:add";
  VRUtils.waitVREventListener(eventName, ()=>{
    //console.log("video: after waitVREventListener, calling pointController:add, key=", key);

    VRUtils.fireVREvent(eventName, key, x, y, z);

  });


}

export function removePoint3D(key:string) {
  const eventName = "pointController:remove";
  VRUtils.waitVREventListener(eventName, ()=>{
    VRUtils.fireVREvent(eventName, key);
  });
}

export function CreateAddPointCallback(key:string, x:number, y:number): () => void {
  const refCallback = React.useCallback(node => {
      if (node !== null) {
          removePoint(key);
          
          setOnPoint((key0, x, y)=>{
            if (key !== key0) {
              return;
            }
            if (node != null) {
              //console.log("node", node);
              node.style.transform = "translate(" + x + "px,"+y+"px)";
            } else {
              //console.log("node", node);
            }
          });
          addPoint(key, x, y);
      } else {

      }
  }, [key, x, y]);
  return refCallback;
}

export function CreateAddPoint3DCallback(key:string, x:number, y:number, z:number, loadingCompleted:any, skipLookAtXYZ?: boolean,
    lookAt_x?:number, lookAt_y?:number, lookAt_z?:number
  ): () => void {
  const result = React.useCallback(node => {
      if (!loadingCompleted) {
        return;
      }
      if (node != null) {
          node.style.visibility = "hidden";
          removePoint3D(key);
          var p = [x, y, z];
          
          if (skipLookAtXYZ !== true) {
            console.log("lookAt:", p[0], p[1], p[2]);
            VRUtils.fireVREvent("smoothLookat", new window.pc.Vec3(p[0], p[1], p[2]) );
          } else if (lookAt_x != null) {
            console.log("lookAt(1):", lookAt_x, lookAt_y, lookAt_z);
            VRUtils.fireVREvent("smoothLookat", new window.pc.Vec3(lookAt_x, lookAt_y, lookAt_z) );
          }

          addPoint3D(key, p[0], p[1], p[2], node );
      } else {
        removePoint3D(key);
      }
  }, [loadingCompleted, key, x, y, z, skipLookAtXYZ, lookAt_x, lookAt_y, lookAt_z]);
  return result;
}
